/* ============================================================
   ÉTAPE 6: TRANCHES DE CAPACITÉ (Phase 5)
   ============================================================ */

import { CapacityBracketsSelector } from '../CapacityBracketsSelector';
import { CapacityBracket } from '../../../../types/capacity-brackets.types';
import { SaveButton } from '../SaveButton';

interface Step6Props {
  data: any;
  onChange: (updates: any) => void;
  onSave?: () => void;
  isSaving?: boolean;
}

export function Step6CapacityBrackets({ data, onChange, onSave, isSaving }: Step6Props) {
  const capacityBrackets: CapacityBracket[] = data.capacityBrackets || [];

  const handleBracketsChange = (brackets: CapacityBracket[]) => {
    onChange({ capacityBrackets: brackets });
  };

  return (
    <div>
      <div style={{
        padding: '1.5rem',
        background: 'linear-gradient(135deg, rgba(0,117,141,0.05) 0%, rgba(0,48,60,0.02) 100%)',
        borderRadius: '12px',
        marginBottom: '2rem',
        border: '2px solid rgba(0,117,141,0.1)',
      }}>
        <p style={{ fontSize: '0.95rem', color: '#00303c', margin: 0, lineHeight: '1.6' }}>
          Définissez les tranches de capacité pour votre espace. Chaque tranche peut avoir un tarif forfaitaire 
          ou des tarifs différents selon la durée (demi-journée / journée complète).
        </p>
      </div>

      <CapacityBracketsSelector
        brackets={capacityBrackets}
        onChange={handleBracketsChange}
        data={data}
      />

      {/* Bouton Sauvegarder */}
      {onSave && (
        <SaveButton
          onSave={onSave}
          isSaving={isSaving || false}
        />
      )}
    </div>
  );
}
